import { borderVariables, primitives } from '@sylveraio/tailwind'
import type { ChartOptions, Plugin } from 'chart.js'
import type { ChartType } from './types'

export const DEFAULT_COLORS = [
  primitives['neon-blue']['500'],
  primitives['green']['700'],
  primitives['red']['600'],
  primitives['coral']['500'],
  primitives['lemon']['700'],
  primitives['mauve']['600'],
  primitives['forest']['700'],
  primitives['burgundy']['700'],
]

export const DEFAULT_HOVER_OPTIONS: ChartOptions<ChartType>['hover'] = {
  mode: 'nearest',
  axis: 'x',
  intersect: false,
}

export const CUSTOM_BORDER_PLUGIN: Plugin<ChartType> = {
  id: 'customBorderPlugin',
  beforeDraw: (chart) => {
    const {
      ctx,
      chartArea: { left, top, width, height },
    } = chart
    ctx.save()
    ctx.strokeStyle = borderVariables['default']
    // 1.25 used to hide any grid lines that are drawn on the border
    ctx.lineWidth = 1.25
    ctx.strokeRect(left, top, width, height)
    ctx.restore()
  },
}

// This plugin will draw a vertical line on the x-axis of the chart at the
// x-coordinate of the active element (i.e the one that is hovered over).
export const CUSTOM_INTERSECTING_LINE_PLUGIN: Plugin<ChartType> = {
  id: 'customIntersectingLinePlugin',
  beforeDraw: (chart) => {
    const activeElements = chart.getActiveElements()

    // Check if there are active elements and if they belong to a line dataset
    if (activeElements.length > 0) {
      const lineChartElement = activeElements.find(
        (element) => chart.data.datasets[element.datasetIndex].type === 'line',
      )

      // Only apply the plugin if the dataset is of type 'line'
      if (typeof lineChartElement !== 'undefined') {
        const ctx = chart.ctx
        const x = lineChartElement.element.x

        ctx.save()
        ctx.beginPath()
        ctx.moveTo(x, chart.chartArea.top)
        ctx.lineTo(x, chart.chartArea.bottom)
        ctx.lineWidth = 1
        ctx.strokeStyle = borderVariables['strong']
        ctx.stroke()
        ctx.restore()
      }
    }
  },
}

export const UI_STRINGS = {
  noDataTitle: 'No data to display',
  noDataDescription: 'There is currently no data available for this chart',
}
